module.exports = __webpack_public_path__ + "static/media/empty-search.74f8cf8e.svg";